module.exports = __webpack_public_path__ + "img/vanilla_dark.7a3dec74.svg";